import { render, staticRenderFns } from "./TestimonialsSection.vue?vue&type=template&id=0ddd63b0&scoped=true"
import script from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TestimonialsSection.vue?vue&type=style&index=0&id=0ddd63b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd63b0",
  null
  
)

export default component.exports